import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProjectDashboard = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
  {
    id: 1,
    title: "Mangrove Restoration Initiative",
    status: "active",
    progress: 78,
    location: "Coastal Buffer Zone",
    startDate: "2025-03-15",
    endDate: "2026-03-14",
    image: "",
    imageAlt: "",
    coordinator: "Maria Santos",
    volunteers: 45,
    targetVolunteers: 60,
    description: "Restoring 15 hectares of degraded mangrove ecosystems to protect coastlines from erosion and provide critical habitat for marine species.",
    objectives: [
    "Plant 25,000 mangrove seedlings",
    "Establish 3 community nurseries",
    "Train 50 local residents in mangrove care",
    "Monitor survival rates quarterly"],

    achievements: [
    "19,500 seedlings planted (78% of target)",
    "2 nurseries operational",
    "42 residents trained",
    "87% seedling survival rate"],

    impact: {
      environmental: "15 hectares restored, 200+ marine species benefited",
      economic: "₱2.3M in coastal protection value",
      social: "45 families engaged, 12 jobs created"
    },
    nextMilestone: "Complete third nursery by January 2026",
    volunteerRoles: ["Planting", "Nursery maintenance", "Monitoring", "Community outreach"]
  },
  {
    id: 2,
    title: "Endemic Species Education Program",
    status: "active",
    progress: 92,
    location: "Local Schools Network",
    startDate: "2025-01-10",
    endDate: "2025-12-20",
    image: "",
    imageAlt: "",
    coordinator: "Roberto Cruz",
    volunteers: 28,
    targetVolunteers: 30,
    description: "Comprehensive environmental education curriculum reaching 2,000 students across 15 schools, focusing on PPSRNP's unique biodiversity.",
    objectives: [
    "Develop age-appropriate curriculum for grades 1-6",
    "Train 30 teacher-facilitators",
    "Conduct 120 classroom sessions",
    "Organize 4 field trips to the park"],

    achievements: [
    "Curriculum completed and distributed",
    "28 teachers trained",
    "110 sessions completed (1,850 students reached)",
    "3 field trips conducted"],

    impact: {
      environmental: "2,000+ students educated on conservation",
      economic: "₱450K in educational materials distributed",
      social: "15 schools engaged, 30 teachers empowered"
    },
    nextMilestone: "Final field trip and program evaluation in December 2025",
    volunteerRoles: ["Teaching", "Curriculum development", "Field trip coordination", "Material preparation"]
  },
  {
    id: 3,
    title: "Sustainable Livelihood Cooperative",
    status: "active",
    progress: 65,
    location: "Barangay Tagabinet",
    startDate: "2025-06-01",
    endDate: "2026-05-31",
    image: "",
    imageAlt: "",
    coordinator: "Elena Domingo",
    volunteers: 52,
    targetVolunteers: 50,
    description: "Establishing a women-led cooperative producing sustainable handicrafts from non-timber forest products, creating alternative livelihoods.",
    objectives: [
    "Form cooperative with 50 members",
    "Complete business and craft training",
    "Establish production facility",
    "Secure 3 major buyers"],

    achievements: [
    "52 members enrolled",
    "Training 80% complete",
    "Facility operational",
    "2 major buyers secured (Manila boutiques)"],

    impact: {
      environmental: "Zero-waste production, sustainable harvesting practices",
      economic: "₱780K generated in first 6 months",
      social: "52 women empowered, 15 families lifted above poverty line"
    },
    nextMilestone: "Secure third major buyer and expand product line",
    volunteerRoles: ["Business mentoring", "Marketing support", "Quality control", "Skills training"]
  },
  {
    id: 4,
    title: "Traditional Knowledge Documentation",
    status: "active",
    progress: 55,
    location: "Tagbanua Communities",
    startDate: "2025-04-01",
    endDate: "2026-12-31",
    image: "",
    imageAlt: "",
    coordinator: "Dr. Jasmine Reyes",
    volunteers: 12,
    targetVolunteers: 15,
    description: "Comprehensive documentation of indigenous Tagbanua ecological knowledge, traditional conservation practices, and medicinal plant usage.",
    objectives: [
    "Interview 30 knowledge keepers",
    "Document 200+ traditional practices",
    "Create multimedia archive",
    "Publish bilingual knowledge book"],

    achievements: [
    "18 elders interviewed",
    "127 practices documented",
    "Video archive 60% complete",
    "Book manuscript 40% complete"],

    impact: {
      environmental: "Preservation of centuries-old conservation wisdom",
      economic: "₱1.2M research grant secured",
      social: "Cultural heritage preserved, intergenerational knowledge transfer"
    },
    nextMilestone: "Complete remaining interviews by March 2026",
    volunteerRoles: ["Interview assistance", "Translation", "Video documentation", "Transcription"]
  },
  {
    id: 5,
    title: "Youth Conservation Leadership Academy",
    status: "planning",
    progress: 25,
    location: "Puerto Princesa City",
    startDate: "2026-01-15",
    endDate: "2026-12-15",
    image: "",
    imageAlt: "",
    coordinator: "Mark Gonzales",
    volunteers: 8,
    targetVolunteers: 25,
    description: "Year-long leadership development program training 50 young people (ages 16-24) in conservation science, community organizing, and environmental advocacy.",
    objectives: [
    "Recruit and select 50 youth participants",
    "Deliver 12 monthly training modules",
    "Facilitate 4 community action projects",
    "Create youth conservation network"],

    achievements: [
    "Program curriculum designed",
    "Partnership with 3 universities established",
    "Recruitment campaign launched",
    "8 volunteer mentors recruited"],

    impact: {
      environmental: "Next generation of conservation leaders",
      economic: "₱850K program budget secured",
      social: "50 youth empowered, 4 communities benefited"
    },
    nextMilestone: "Complete participant recruitment by December 2025",
    volunteerRoles: ["Mentoring", "Module facilitation", "Project supervision", "Network coordination"]
  },
  {
    id: 6,
    title: "Plastic-Free Communities Campaign",
    status: "active",
    progress: 88,
    location: "5 Barangays",
    startDate: "2025-02-01",
    endDate: "2025-12-31",
    image: "",
    imageAlt: "",
    coordinator: "Ana Mercado",
    volunteers: 156,
    targetVolunteers: 150,
    description: "Community-wide initiative to eliminate single-use plastics through education, alternative provision, and waste management infrastructure.",
    objectives: [
    "Engage 5 barangays (2,000 households)",
    "Distribute 2,000 reusable bag sets",
    "Establish 10 refill stations",
    "Reduce plastic waste by 60%"],

    achievements: [
    "5 barangays fully engaged",
    "1,850 bag sets distributed",
    "9 refill stations operational",
    "54% plastic waste reduction achieved"],

    impact: {
      environmental: "12 tons of plastic waste prevented",
      economic: "₱340K in waste management savings",
      social: "2,000 households engaged, 156 active volunteers"
    },
    nextMilestone: "Launch final refill station and achieve 60% reduction target",
    volunteerRoles: ["Community outreach", "Refill station management", "Waste audits", "Social media advocacy"]
  }];


  const statusColors = {
    active: { bg: 'bg-success/10', text: 'text-success', border: 'border-success' },
    planning: { bg: 'bg-info/10', text: 'text-info', border: 'border-info' },
    completed: { bg: 'bg-accent/10', text: 'text-accent', border: 'border-accent' }
  };

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Active Conservation Projects
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Track real-time progress of community-led conservation initiatives. Join ongoing projects or propose new ones.
          </p>
        </div>

        {/* Summary Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-card p-6 rounded-lg shadow-conservation">
            <div className="flex items-center justify-between mb-2">
              <Icon name="FolderOpen" size={24} className="text-accent" />
              <span className="text-sm text-gray-400">Total Projects</span>
            </div>
            <div className="text-3xl font-bold text-white">156</div>
            <div className="text-sm text-success mt-1">+12 this month</div>
          </div>
          <div className="bg-card p-6 rounded-lg shadow-conservation">
            <div className="flex items-center justify-between mb-2">
              <Icon name="Users" size={24} className="text-info" />
              <span className="text-sm text-gray-400">Active Volunteers</span>
            </div>
            <div className="text-3xl font-bold text-white">2,847</div>
            <div className="text-sm text-success mt-1">+156 this month</div>
          </div>
          <div className="bg-card p-6 rounded-lg shadow-conservation">
            <div className="flex items-center justify-between mb-2">
              <Icon name="TrendingUp" size={24} className="text-success" />
              <span className="text-sm text-gray-400">Communities Engaged</span>
            </div>
            <div className="text-3xl font-bold text-white">47</div>
            <div className="text-sm text-success mt-1">+3 this quarter</div>
          </div>
          <div className="bg-card p-6 rounded-lg shadow-conservation">
            <div className="flex items-center justify-between mb-2">
              <Icon name="DollarSign" size={24} className="text-accent" />
              <span className="text-sm text-gray-400">Economic Impact</span>
            </div>
            <div className="text-3xl font-bold text-white">₱8.4M</div>
            <div className="text-sm text-success mt-1">+₱1.2M this year</div>
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {projects?.map((project) => {
            const statusStyle = statusColors?.[project?.status];
            return (
              <div
                key={project?.id}
                className="bg-card rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg transition-all animation-organic cursor-pointer group"
                onClick={() => setSelectedProject(project)}>

                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <Image
                    src={project?.image}
                    alt={project?.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                  <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-medium ${statusStyle?.bg} ${statusStyle?.text} border ${statusStyle?.border}`}>
                    {project?.status?.charAt(0)?.toUpperCase() + project?.status?.slice(1)}
                  </div>
                </div>
                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-accent transition-colors line-clamp-2">
                    {project?.title}
                  </h3>

                  <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 text-sm text-gray-400">
                      <Icon name="MapPin" size={16} />
                      <span>{project?.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-400">
                      <Icon name="User" size={16} />
                      <span>{project?.coordinator}</span>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="mb-4">
                    <div className="flex items-center justify-between text-sm mb-2">
                      <span className="text-gray-400">Progress</span>
                      <span className="text-accent font-medium">{project?.progress}%</span>
                    </div>
                    <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-500"
                        style={{ width: `${project?.progress}%` }} />

                    </div>
                  </div>

                  {/* Volunteers */}
                  <div className="flex items-center justify-between p-3 bg-muted rounded-lg mb-4">
                    <div className="flex items-center gap-2">
                      <Icon name="Users" size={18} className="text-info" />
                      <span className="text-sm text-gray-300">Volunteers</span>
                    </div>
                    <span className="text-sm font-medium text-white">
                      {project?.volunteers}/{project?.targetVolunteers}
                    </span>
                  </div>

                  <p className="text-sm text-gray-300 line-clamp-3 mb-4">
                    {project?.description}
                  </p>

                  <Button variant="outline" size="sm" fullWidth>
                    View Details
                  </Button>
                </div>
              </div>);

          })}
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-conservation rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Have a Project Idea?
          </h3>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Community-led initiatives are the heart of our conservation success. Submit your project proposal and get support from our network.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button variant="default" iconName="Plus" iconPosition="left">
              Submit Project Proposal
            </Button>
            <Button variant="outline">
              View Project Guidelines
            </Button>
          </div>
        </div>
      </div>
      {/* Project Detail Modal */}
      {selectedProject &&
      <div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={() => setSelectedProject(null)}>

          <div
          className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
          onClick={(e) => e?.stopPropagation()}>

            {/* Modal Header */}
            <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-white">{selectedProject?.title}</h3>
              <button
              onClick={() => setSelectedProject(null)}
              className="p-2 hover:bg-muted rounded-lg transition-colors">

                <Icon name="X" size={24} className="text-gray-400" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-6">
              {/* Image */}
              <div className="relative h-64 rounded-lg overflow-hidden">
                <Image
                src={selectedProject?.image}
                alt={selectedProject?.imageAlt}
                className="w-full h-full object-cover" />

              </div>

              {/* Project Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="MapPin" size={18} className="text-accent" />
                    <span>{selectedProject?.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="User" size={18} className="text-accent" />
                    <span>Coordinator: {selectedProject?.coordinator}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="Users" size={18} className="text-accent" />
                    <span>{selectedProject?.volunteers}/{selectedProject?.targetVolunteers} Volunteers</span>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="Calendar" size={18} className="text-accent" />
                    <span>Start: {new Date(selectedProject.startDate)?.toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="CalendarCheck" size={18} className="text-accent" />
                    <span>End: {new Date(selectedProject.endDate)?.toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="Target" size={18} className="text-accent" />
                    <span>Progress: {selectedProject?.progress}%</span>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div>
                <h4 className="text-lg font-bold text-white mb-2">Project Description</h4>
                <p className="text-gray-300 leading-relaxed">{selectedProject?.description}</p>
              </div>

              {/* Objectives & Achievements */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-lg font-bold text-white mb-3">Objectives</h4>
                  <ul className="space-y-2">
                    {selectedProject?.objectives?.map((objective, index) =>
                  <li key={index} className="flex items-start gap-2 text-gray-300">
                        <Icon name="Target" size={16} className="text-info mt-1 flex-shrink-0" />
                        <span>{objective}</span>
                      </li>
                  )}
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-white mb-3">Achievements</h4>
                  <ul className="space-y-2">
                    {selectedProject?.achievements?.map((achievement, index) =>
                  <li key={index} className="flex items-start gap-2 text-gray-300">
                        <Icon name="CheckCircle2" size={16} className="text-success mt-1 flex-shrink-0" />
                        <span>{achievement}</span>
                      </li>
                  )}
                  </ul>
                </div>
              </div>

              {/* Impact */}
              <div className="bg-muted rounded-lg p-6">
                <h4 className="text-lg font-bold text-white mb-4">Project Impact</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Leaf" size={18} className="text-success" />
                      <span className="text-sm font-medium text-success">Environmental</span>
                    </div>
                    <p className="text-sm text-gray-300">{selectedProject?.impact?.environmental}</p>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="DollarSign" size={18} className="text-accent" />
                      <span className="text-sm font-medium text-accent">Economic</span>
                    </div>
                    <p className="text-sm text-gray-300">{selectedProject?.impact?.economic}</p>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Users" size={18} className="text-info" />
                      <span className="text-sm font-medium text-info">Social</span>
                    </div>
                    <p className="text-sm text-gray-300">{selectedProject?.impact?.social}</p>
                  </div>
                </div>
              </div>

              {/* Next Milestone */}
              <div className="bg-accent/10 border border-accent rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <Icon name="Flag" size={20} className="text-accent mt-0.5 flex-shrink-0" />
                  <div>
                    <div className="text-sm font-medium text-accent mb-1">Next Milestone</div>
                    <div className="text-sm text-gray-300">{selectedProject?.nextMilestone}</div>
                  </div>
                </div>
              </div>

              {/* Volunteer Roles */}
              <div>
                <h4 className="text-lg font-bold text-white mb-3">Available Volunteer Roles</h4>
                <div className="flex flex-wrap gap-2">
                  {selectedProject?.volunteerRoles?.map((role, index) =>
                <span
                  key={index}
                  className="px-4 py-2 bg-primary/20 text-primary rounded-full text-sm font-medium">

                      {role}
                    </span>
                )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-wrap gap-3 pt-4 border-t border-border">
                <Button variant="default" iconName="UserPlus" iconPosition="left">
                  Join This Project
                </Button>
                <Button variant="outline" iconName="Share2" iconPosition="left">
                  Share Project
                </Button>
                <Button variant="ghost" iconName="Download" iconPosition="left">
                  Download Report
                </Button>
              </div>
            </div>
          </div>
        </div>
      }
    </section>);

};

export default ProjectDashboard;